import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CustomProvider } from 'rsuite';
import faIR from 'rsuite/locales/fa_IR';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<CustomProvider locale={faIR} rtl>
  <App />
</CustomProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
